<template>
  <b-col cols="12" class="text-left mt-4">
    <div class="avatar-box d-flex">
      <div class="avatar mt-5">
        <b-icon
          icon="hand-index-thumb"
          variant="danger"
          font-scale="4.5"
          class="border rounded-circle border-danger bg-white p-3"
        ></b-icon>
      </div>
      <div class="black-box">
        <b-overlay :show="loading" rounded="sm">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" v-if="show">
            <b-form-group id="input-group-name" label="* Nome:" label-for="input-name">
              <b-form-input
                id="input-name"
                v-model="user.first_name"
                required
                placeholder="Inserisci il tuo nome"
                name="first_name"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-surname" label="* Cognome:" label-for="input-surname">
              <b-form-input
                id="input-surname"
                v-model="user.last_name"
                required
                placeholder="Inserisci il tuo cognome"
                name="last_name"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-mail" label="* Email:" label-for="input-mail">
              <b-form-input
                id="input-mail"
                v-model="user.email"
                type="email"
                required
                placeholder="Inserisci la tua email"
                name="email"
              ></b-form-input>
            </b-form-group>

            <b-row>
              <b-col>
                <b-form-group id="input-group-mail" label="* Password:" label-for="input-mail">
                  <b-form-input
                    v-model="user.password"
                    type="password"
                    required
                    placeholder="Inserisci la tua password"
                    name="password"
                    v-validate="'required'"
                    ref="password"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group id="input-group-mail" label="* Conferma la password:" label-for="input-mail">
                  <b-form-input
                    v-model="user.password_confirm"
                    type="password"
                    required
                    placeholder="Conferma la tua password"
                    name="password_confirm"
                    v-validate="'required|confirmed:password'"
                    data-vv-as="password"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group
              id="input-group-organization"
              :label="(userType == 'organization' ? '* ' : ' ') + 'Organizzazione:'"
              label-for="input-organization"
              v-if="userType == 'organization'"
            >
              <v-select
                id="input-organization"
                :options="organizations"
                v-model="user.organization_id"
                label="name"
                placeholder="Seleziona la tua organizzazione"
                v-if="userType == 'organization'"
                name="organization"
                :reduce="(organization) => organization.id"
                required
                v-validate="'required'"
              ></v-select>
              <br />
              <b-row>
                <b-col>
                  <label>* Codice Accesso Organizzazione:</label>
                </b-col>
                <b-col>
                  <b-form-input
                    id="input-code"
                    v-model="user.code"
                    type="text"
                    required
                    placeholder="Inserisci il codice"
                    name="code"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row v-if="userType == 'organization'">
                <b-col>
                  <small>
                    <br />Non hai un <b>codice accesso</b>? Chiedi al referente della tua organizzazione di fornirtelo.
                  </small>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b>Non trovi la tua organizzazione?</b>
                </b-col>
                <b-col>
                  <p><a class="badge badge-primary" :href="url_accredita">accreditati</a><br /></p>
                </b-col>
              </b-row>
              <!--
              <small
                >E' rapido e facile. Compila <a :href="url_accredita">la richiesta di accreditamento</a>, entro qualche
                ora riceverai il codice che permetterà agli altri membri dell'organizzazione di iscriversi velocemente e
                richiedere traduzioni.</small
              >
              -->
            </b-form-group>

            <!--
            <b-row v-if="userType == 'organization'"
              ><b-col cols="auto"><label>Codice Accesso Organizzazione:</label></b-col
              ><b-col cols="auto">
                <b-form-input
                  id="input-code"
                  v-model="user.code"
                  type="text"
                  required
                  placeholder="Inserisci il codice"
                  name="code"
                ></b-form-input> </b-col></b-row
            >
            -->

            <b-form-group id="input-group-consens">
              <b-form-checkbox name="compliance" v-validate="'required:true'" v-model="compliance">
                * Accetto le
                <a href="/compliance" target="_blank">condizioni generali</a>
                del servizio
              </b-form-checkbox>

              <b-form-checkbox name="privacy" v-validate="'required:true'" v-model="privacy">
                * Acconsento al trattamento dei dati secondo la
                <a href="/privacy" target="_blank">privacy policy di LanguageAid</a>
              </b-form-checkbox>
            </b-form-group>

            <hr />
            <div v-if="userType == 'translator'">
              <b-form-group id="input-group-translator">
                <b
                  >Sono disposto ad eseguire traduzioni e/o revisioni a titolo volontario nelle seguenti lingue</b
                >
              </b-form-group>
              <!-- <v-select multiple :options="langs" v-model="user.langs" label="description" name="langs"></v-select>
              <span class="pl-2 flag" v-for="(item, index) in user.langs" :key="index"> {{ getFlag(item.id) }} </span> -->
              <label class="mdb-main-label">Da (lingua sorgente)</label>
              <v-select multiple :options="langs" v-model="user.src_langs" label="description" name="langs"></v-select>
              <br>
              <label class="mdb-main-label">A (lingua destinazione)</label>
              <v-select multiple :options="langs" v-model="user.dest_langs" label="description" name="langs"></v-select>
            </div>

            <div class="m-2">
              <b-button pill type="submit" variant="primary" class="m-2" :disabled="loading">Registrati</b-button>
              <b-button pill type="reset" variant="outline-danger">Cancella</b-button>
            </div>
            <small>* I campi contrassegnati da un asterisco sono obbligatori.</small>
            <b-alert :show="errorMessage.length" variant="danger">{{ errorMessage }}</b-alert>
            <ul>
              <li v-for="error in errors.all()" :key="error.id">{{ error }}</li>
            </ul>
          </b-form>
        </b-overlay>
      </div>
    </div>
  </b-col>
</template>

<script>
//import axios from "axios";
import UserService from "@/services/user.service";
import Util from "@/mixing/util";
import User from "@/models/user";

export default {
  name: "Register",
  mixins: [Util],
  data() {
    return {
      //url_accredita: process.env.VUE_APP_ROOT + "/organizations/add",
      url_accredita: "/accreditation",
      user: new User("", ""),
      langs: [],
      organizations: [],
      show: true,
      userType: this.$route.params.userType,
      loading: false,
      message: null,
      errorMessage: "",
      compliance: false,
      privacy: false,
    };
  },
  mounted() {
    UserService.getLanguages().then((response) => (this.langs = response.data));
    UserService.getOrganizationsList().then((response) => (this.organizations = response.data));
  },
  methods: {
    /* Josph K. code not use for backend control /*
    myEvent: function() {
      let email = this.user.email
      this.validateEmail(email)
    },
    validateEmail: function(email) {
      let mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if(email.match(mailformat)) {
        axios.get(process.env.VUE_APP_ROOT + "/users/checkmail/" + email + ".json", { headers: 'Access-Control-Allow-Origin: *' })
          .then(response => (this.userExists = response.data))
      }
    },
    /* end of code */
    onSubmit() {
      console.log(this.user);
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.user.userType = this.userType;
        this.$store.dispatch("auth/register", this.user).then(
          () => {
            this.$bvModal
              .msgBoxOk("Utente registrato con successo. Ora puoi fare login.", {
                title: "Registrato con successo",
              })
              .then(() => {
                this.$router.push("/login/" + this.userType);
              });
          },
          (error) => {
            this.loading = false;
            this.errorMessage = error.response.data.message;
            console.log(error.response.data.message);
          }
        );
      });
      this.loading = false;
    },
    onReset() {
      this.user = new User("", "");
      this.user.consens = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>
<style></style>
